import enterEdit from "../smes/loan/v2024_3/enterEdit.vue";

const EnteEnterprise = () => import(/* webpackChunkName: "proj" */ '@/components/ente/Enterprise');
const EnteInfo = () => import(/* webpackChunkName: "proj" */ '@/components/ente/ente//Info');
const EnteEdit = () => import(/* webpackChunkName: "proj" */ './ente/Edit_v2024');


export default {
  routes: [
    //项目列表
    {
      path: '/ente/enterprise',
      name: 'ente_enterprise',
      component: EnteEnterprise
    },

    //项目信息查看
    {
      path: '/ente/ente/info',
      name: 'ente_info',
      component: EnteEdit,
      meta:{public:true}
    },

    //项目信息编辑
    {
      path: '/ente/ente/edit',
      name: 'ente_edit',
      component: EnteEdit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ente/router.js